"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeConfig = exports.createOSWApptInfoMachine = exports.machineJSON = void 0;
const xstate_1 = require("xstate");
const load_script_1 = __importDefault(require("load-script"));
const epicOSWUtils_1 = require("../../lib/epicOSWUtils");
const States_1 = require("../../lib/constants/States");
const actions = {
    setExternalIDAndVisitType: (0, xstate_1.assign)({
        externalID: (ctx, ev) => ev.data.externalID,
        visitType: (ctx, ev) => ev.data.visitType
    }),
    loadExternalJS: (ctx) => {
        (0, load_script_1.default)(ctx.epicOSWConfig.open_scheduling_js_url, {
            async: false
        });
    }
};
const guards = {
    cannotCompleteExternalBooking: (ctx, ev) => {
        const { externalID, visitType } = ev.data;
        return !externalID || !visitType;
    }
};
const services = {
    getExternalIDAndVisitType: (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const { provider, epicOSWConfig } = ctx;
        return {
            externalID: (0, epicOSWUtils_1.getExternalIDForProvider)(provider),
            visitType: (0, epicOSWUtils_1.getExtVisitTypeForProvider)(provider, epicOSWConfig)
        };
    })
};
// This is exposed for snapshot testing
const machineJSON = ({ provider, epicOSWConfig }) => ({
    id: `Machine__${States_1.oswApptInfo}`,
    initial: States_1.initializing,
    context: {
        provider,
        epicOSWConfig
    },
    states: {
        [States_1.initializing]: {
            invoke: {
                id: 'getExternalIDAndVisitType',
                src: 'getExternalIDAndVisitType',
                onDone: [
                    { cond: 'cannotCompleteExternalBooking', target: States_1.error },
                    {
                        actions: ['setExternalIDAndVisitType', 'loadExternalJS'],
                        target: States_1.success
                    }
                ],
                onError: States_1.error
            }
        },
        [States_1.success]: {},
        [States_1.error]: {}
    }
});
exports.machineJSON = machineJSON;
const createOSWApptInfoMachine = (_a) => {
    var { config = (0, exports.makeConfig)() } = _a, props = __rest(_a, ["config"]);
    return (0, xstate_1.Machine)((0, exports.machineJSON)(props)).withConfig(config);
};
exports.createOSWApptInfoMachine = createOSWApptInfoMachine;
const makeConfig = () => ({ actions, guards, services });
exports.makeConfig = makeConfig;
//# sourceMappingURL=oswApptInfo.js.map